import { IStackProps } from 'native-base';
import { ReactNode } from 'react';
import { getStylesheet } from '../../styles';
import { Heading, Layout, Text } from '../core';

type PageHeaderProps = IStackProps & {
  children?: ReactNode;
  overtext?: string;
  textColor?: string;
  title: string;
  undertext?: string;
};

export const PageHeader = ({
  children,
  overtext,
  textColor = 'darkText',
  title,
  undertext,
  ...topStyles
}: PageHeaderProps): JSX.Element => {
  return (
    <Layout.HStack {...styles.header} testID="page-header" {...topStyles}>
      <Layout.VStack flexGrow={1} flexShrink={1} space={1}>
        {overtext !== undefined && <Heading.h6 color={textColor}>{overtext}</Heading.h6>}

        <Heading.h1 color={textColor}>{title}</Heading.h1>

        {undertext !== undefined && <Text.para color={textColor}>{undertext}</Text.para>}
      </Layout.VStack>

      {children}
    </Layout.HStack>
  );
};

const styles = getStylesheet({
  header: {
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingY: 4,
    width: '100%',
  },
});
